export const CartLineDetailsTabNameEnum = Object.freeze({
    FIELDS: 'fields',
    OFFERS: 'offers',
    RETURNS: 'returns',
});
